/**
 * Portail client (§5 bis, décisions du 18/10/2026) : sa propre session, une
 * route par page. Les adresses portées par les e-mails (`/portail/connexion`)
 * ne changent pas.
 */
import { lazy } from 'react';
import { Navigate } from 'react-router-dom';
import type { ExternalRoute } from '../../app/route-types.js';

const PortalLoginPage = lazy(() => import('./PortalLogin.js').then((m) => ({ default: m.PortalLoginPage })));
const PortalConsumePage = lazy(() => import('./PortalLogin.js').then((m) => ({ default: m.PortalConsumePage })));
const PortalHomePage = lazy(() => import('./PortalHome.js').then((m) => ({ default: m.PortalHomePage })));
const PortalDocumentsPage = lazy(() => import('./PortalDocuments.js').then((m) => ({ default: m.PortalDocumentsPage })));
const PortalDocumentPage = lazy(() => import('./PortalDocuments.js').then((m) => ({ default: m.PortalDocumentPage })));
const PortalRequestsPage = lazy(() => import('./PortalRequests.js').then((m) => ({ default: m.PortalRequestsPage })));
const PortalRequestPage = lazy(() => import('./PortalRequests.js').then((m) => ({ default: m.PortalRequestPage })));
const PortalRequestNewPage = lazy(() => import('./PortalRequestNew.js').then((m) => ({ default: m.PortalRequestNewPage })));
const PortalInterventionPage = lazy(() => import('./PortalRecords.js').then((m) => ({ default: m.PortalInterventionPage })));
const PortalEquipmentPage = lazy(() => import('./PortalRecords.js').then((m) => ({ default: m.PortalEquipmentPage })));
const PortalFeedbackPage = lazy(() => import('./PortalForms.js').then((m) => ({ default: m.PortalFeedbackPage })));
const PortalHistoryNewPage = lazy(() => import('./PortalForms.js').then((m) => ({ default: m.PortalHistoryNewPage })));

export const portalRoutes: ExternalRoute[] = [
  { path: '/portail', element: <PortalLoginPage /> },
  { path: '/portail/connexion', element: <PortalConsumePage /> },
  { path: '/portail/dossier', element: <PortalHomePage /> },
  { path: '/portail/documents', element: <PortalDocumentsPage /> },
  { path: '/portail/documents/:kind/:id', element: <PortalDocumentPage /> },
  { path: '/portail/demandes', element: <PortalRequestsPage /> },
  { path: '/portail/demandes/nouvelle', element: <PortalRequestNewPage /> },
  { path: '/portail/demandes/:reference', element: <PortalRequestPage /> },
  { path: '/portail/interventions/:id', element: <PortalInterventionPage /> },
  { path: '/portail/interventions/:id/avis', element: <PortalFeedbackPage /> },
  { path: '/portail/machines/:id', element: <PortalEquipmentPage /> },
  { path: '/portail/machines/:id/historique/nouveau', element: <PortalHistoryNewPage /> },
  // Une adresse inconnue du portail ramène au dossier (ou à la connexion sans session).
  { path: '/portail/*', element: <Navigate to="/portail/dossier" replace /> },
];
